'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isFramed = exports.isFramed = function isFramed() {
  return window !== window.top;
};